import React, { createContext, useState } from "react";

const TodoListDataContext = createContext([]);

function TodoListDataProvider(props) {
  const [todoListData, setTodoListData] = useState([]);

  const deleteTodoLists = (ids) => {
    const newTodoListData = todoListData.filter((f) => !ids.includes(f.id));
    setTodoListData(newTodoListData);
  };

  return (
    <TodoListDataContext.Provider
      value={{ todoListData, setTodoListData, deleteTodoLists }}
    >
      {props.children}
    </TodoListDataContext.Provider>
  );
}

export { TodoListDataContext, TodoListDataProvider };
